import { observer } from "mobx-react-lite";
import { Fragment, useEffect, useRef } from "react";
import * as echarts from "echarts";
import { CommonStore } from "../../store";

function ANumber(props: any) {
  const chartRef = useRef(null);

  useEffect(() => {
    const fn = async () => {
      await CommonStore.getHomePageData();
      const chartDom = chartRef.current;
      if (chartDom) {
        let chartInstance = echarts.init(chartDom);
        chartInstance.setOption(CommonStore.xpool);
      }
    };
    fn();
  }, []);

  //创建一个resize事件
  const echartsResize = () => {
    echarts.init(chartRef.current).resize();
  };

  //监听echartsResize函数，实现图表自适应
  window.addEventListener("resize", echartsResize);

  //页面卸载，销毁监听
  useEffect(() => {
    return () => {
      window.removeEventListener("resize", echartsResize);
    };
  }, []);
  return (
    <Fragment>
      {CommonStore.homePageDataList.xpoolReadable && (
        <div
          ref={chartRef}
          id="main"
          style={{
            height: "80%",
            width: "100%",
            border: "1px solid rgb(245 245 245)",
            margin: "0 5px",
            padding: "10px",
          }}
        ></div>
      )}
      {!CommonStore.homePageDataList.xpoolReadable && (
        <div
          style={{
            height: "80%",
            width: "100%",
            border: "1px solid rgb(245 245 245)",
            margin: "0 5px",
            padding: "10px",
          }}
        >
          <div
            style={{
              color: "rgb(245 245 245)",
              fontWeight: "800",
              fontSize: "36px",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            暂无权限
          </div>
        </div>
      )}
    </Fragment>
  );
}

export default observer(ANumber);
